<template>
   <div class="mask" v-if="showFlag" >
      <div class="note border flex-col"  >
          <div class="flex flex-row flex-space-between padding-m">
              <div class="font-bold">便签</div>
              <div class="color-blue font-s pointer flex flex-center-cz">
                  <img class="icon1 margin-right-xl" src="@/assets/images/save1.png"  @click="save"/>
                  <img class="icon" src="@/assets/images/guanbi.png" @click="close"/>
              </div>
          </div>
          <div>
              <textarea rows="25" class="full-width  font-m" style="border: none;height: 550px;" v-model="content"></textarea>
          </div>

          <div class="msg-info-sjx"></div>
      </div>
   </div>


</template>


<script>


import {saveNote, getNote} from '@/api/api.js';

export default {
    name: 'Note',
    props: {
        show: {default: false},
    },
    created() {
    },
    watch: {
      show(val) {
          this.showFlag = val
          if (val == true) {
            console.log("load");
            this.load();
          } 
      },
    },
    data() {
        return {
            showFlag: false,
            content:""

        }
    },

    methods: {

        load() {
            getNote().then((res) => {
                console.log(res);
              if (res.data.success == true) {
                this.content = res.data.result.content;
              }
            });
        },

        save() {
            saveNote(this.content).then((res) => {
              if (res.data.success == true) {
                this.$emit("close")
              }
            });
        },
        close() {
          this.$emit("close")
        }

    }
}
</script>


<style scoped>
  .note {
    position: absolute;
    background-color: #fff;
    border-radius: 10px;
    top:50px;
    right: 60px;
    height: 600px;
    width: 325px;
    z-index: 999;
    display: flex;
    flex-direction: column;
    padding: 10px;
  }
  .msg-info-sjx {
    transform: rotate(45deg);
    top: -7px;
    right: 80px;
    width: 10px;
    height: 10px;
    position: absolute;
    border-left: 1px solid rgba(0, 0, 0, .2);
    border-top: 1px solid rgba(0, 0, 0, .2);
    z-index: 9999;
    background-color: #fff;
  }

  .icon1 {
    width: 25px;
    height: 25px;
  }

  .icon {
    width: 22px;
    height: 22px;
  }


</style>



// WEBPACK FOOTER //
// src/modules/note/Note.vue